export default __webpack_public_path__ + "static/media/preview.c394bc9e.png";